
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetooutstationcab() {



    const cardData =
    {
        keyword: 'Pune Outstation Cab',
        heading: 'S9 Travels: Pune Outstation Cab',
        headingDescription: 'S9 Travels offers dependable and comfortable Pune Outstation Cab Services, making your long-distance travel across Maharashtra and beyond smooth, safe, and enjoyable. Whether you’re planning a family vacation, pilgrimage, business trip, or weekend getaway, we provide well-maintained AC sedans, SUVs, and Innova Crysta cabs driven by professional and courteous chauffeurs. Popular routes include Pune to Mumbai, Shirdi, Mahabaleshwar, Lonavala, Goa, Nashik, and Kolhapur, all covered with punctual pickup and doorstep drop facilities. Our transparent pricing ensures no hidden charges, while 24×7 customer assistance makes your journey worry-free. From one-way trips to multi-day tours, S9 Travels offers customized travel packages designed for your comfort, convenience, and budget. Experience the joy of seamless long-distance travel with S9 Travels’ reliable Pune Outstation Cabs — your trusted companion on every road trip.',


        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "A historic fortification in the heart of Pune, Shaniwar Wada was built in 1732 by the Peshwas of the Maratha Empire. Once the seat of the Peshwa rulers, this grand palace is known for its magnificent architecture, massive gateways, and intriguing legends. The evening light and sound show offers a captivating retelling of its history, making it a must-visit for history lovers."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892 by Sultan Muhammed Shah Aga Khan III, this stunning palace holds great historical significance. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters during the Indian independence movement. The palace is surrounded by lush gardens and houses a museum displaying artifacts related to Gandhi's life and legacy."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Perched atop a hill, Sinhagad Fort offers breathtaking panoramic views of the surrounding landscape. This fort, which was the site of the historic Battle of Sinhagad in 1670, is a favorite among trekking enthusiasts. Visitors can explore the ruins, pay homage to the brave warrior Tanaji Malusare, and enjoy local delicacies like pithla bhakri at nearby food stalls."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene retreat for spiritual seekers. It offers a variety of meditation programs, wellness sessions, and yoga classes in a peaceful environment. The ashram attracts visitors from across the globe looking to rejuvenate their mind and body through mindfulness and meditation."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An ancient rock-cut temple dedicated to Lord Shiva, Pataleshwar Cave Temple dates back to the 8th century. Carved out of a single basalt rock, this temple features beautiful stone pillars and a sanctum with a Shiva Lingam. The tranquil atmosphere makes it an ideal spot for those seeking a blend of history, spirituality, and ancient architecture."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This unique museum houses an extensive collection of over 20,000 artifacts, including sculptures, paintings, weapons, musical instruments, and everyday household items from different periods of Indian history. It provides a fascinating insight into the artistic heritage of Maharashtra and India as a whole."
    },
    {
      "title": "Khadakwasla Dam",
      "description": "A scenic getaway just a short drive from Pune, Khadakwasla Dam is a perfect spot for nature lovers and picnickers. The dam, which supplies water to Pune, offers stunning views of the reservoir and nearby hills. The cool breeze and peaceful surroundings make it an excellent location for a leisurely evening outing."
    },
    {
      "title": "Fergusson College Road",
      "description": "Known for its vibrant and youthful energy, Fergusson College Road is a popular hangout spot among students and young travelers. It is lined with cafes, bookstores, street vendors, and shopping outlets. Whether you're looking for trendy fashion, delicious street food, or a lively atmosphere, this street has something for everyone."
    },
    {
      "title": "Lal Mahal",
      "description": "A historically significant landmark, Lal Mahal was originally built in the 1630s by Shahaji Bhosale for his son, Chhatrapati Shivaji Maharaj. Though the original structure was destroyed, the reconstructed Lal Mahal offers a glimpse into the childhood of Shivaji Maharaj and features paintings and artifacts related to his life."
    },
    {
      "title": "Pune-Okayama Friendship Garden",
      "description": "Also known as the Japanese Garden, this beautifully designed landscape park is inspired by the Korakuen Garden in Okayama, Japan. It features manicured lawns, flowing streams, koi ponds, and traditional Japanese-style architecture. It's a perfect place for a peaceful stroll or a relaxing family outing."
    }
],

"services": [
  {
    "name": "Pune Outstation Cab Service",
    "description": "Book reliable and well-maintained Pune outstation cabs with S9 Travels. Our service offers safe, comfortable, and on-time rides for long or short outstation journeys from Pune."
  },
  {
    "name": "Book Outstation Taxi from Pune",
    "description": "S9 Travels makes it easy to book Pune outstation cabs for one-way or round-trip journeys. Enjoy flexible travel options with experienced drivers and clean vehicles."
  },
  {
    "name": "Pune Outstation Car Rental",
    "description": "Rent a comfortable car for your outstation travel from Pune. Our Pune outstation cabs include professional drivers and reliable vehicles for a smooth and enjoyable journey."
  },
  {
    "name": "Affordable Outstation Cabs from Pune",
    "description": "Looking for budget-friendly Pune outstation cabs? S9 Travels offers affordable rates without compromising on safety or comfort, making your trip stress-free and economical."
  },
  {
    "name": "Pune to Nearby City Cabs",
    "description": "Travel from Pune to nearby cities like Mumbai, Lonavala, and Mahabaleshwar with our convenient Pune outstation cab service. Perfect for short-distance, comfortable rides."
  },
  {
    "name": "Private Outstation Taxis from Pune",
    "description": "Enjoy privacy and comfort with our private Pune outstation cabs. Choose from various vehicle types to suit solo travelers, families, or small groups."
  },
  {
    "name": "One-Way Outstation Cabs from Pune",
    "description": "S9 Travels offers convenient and affordable one-way Pune outstation cabs for travelers who don’t require a return trip. Book now for a smooth and cost-effective journey."
  },
  {
    "name": "Round Trip Outstation Cabs from Pune",
    "description": "Planning a round trip? Our Pune outstation cab service ensures a reliable ride both to and from your destination, with flexible scheduling and trusted drivers."
  },
  {
    "name": "Group Travel in Outstation Cabs from Pune",
    "description": "Traveling with family or friends? Book group-friendly Pune outstation cabs with spacious seating and luggage space for a relaxed group journey."
  },
  {
    "name": "Pune to Outstation Trip by Taxi",
    "description": "For business or leisure, book a Pune outstation cab with S9 Travels and enjoy a safe, comfortable journey to your chosen destination outside the city."
  },
  {
    "name": "Comfortable Outstation Travel by Taxi from Pune",
    "description": "Make your outstation travel from Pune stress-free with our comfortable cabs. Our Pune outstation cabs are clean, reliable, and driven by courteous chauffeurs."
  },
  {
    "name": "Pune Outstation Transportation Services",
    "description": "S9 Travels provides professional Pune outstation cab services for all travel needs. Whether it’s a weekend getaway or a business trip, we’ve got you covered."
  }
],

"tableData": [
  ["Pune Outstation Cab Service", "Book Outstation Taxi from Pune"],
  ["Pune Outstation Car Rental", "Affordable Outstation Cabs from Pune"],
  ["Pune to Nearby City Cabs", "Private Outstation Taxis from Pune"],
  ["One-Way Outstation Cabs from Pune", "Round Trip Outstation Cabs from Pune"],
  ["Group Travel in Outstation Cabs from Pune", "Pune to Outstation Trip by Taxi"],
  ["Comfortable Outstation Travel by Taxi from Pune", "Pune Outstation Transportation Services"],
],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Reliable Long-Distance Travel",
    "WhyChoosedescription": "S9 Travels offers a comfortable Pune outstation cab service, ideal for long-distance journeys. Our fleet of well-maintained vehicles, including the Toyota Innova, ensures a smooth, comfortable ride with ample space, air conditioning, and plush seating, making your trip enjoyable no matter the distance."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand that timely travel is essential. Our Pune outstation cab service ensures punctual pick-ups and drop-offs, so you can reach your destination on time without any delays. Whether you're traveling for business, leisure, or a special event, we guarantee reliable service every time."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes and road conditions for outstation trips from Pune. They prioritize safety, comfort, and efficiency, ensuring your journey is smooth and pleasant, no matter the destination."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for Pune outstation cab services. We provide a transparent pricing structure with no hidden charges. You’ll receive a clear breakdown of the cost during the booking process, allowing you to plan your travel budget without surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Outstation Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features like GPS tracking, airbags, and seat belts to ensure a safe and comfortable journey for you and your passengers throughout your outstation trip from Pune."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your outstation trips. Whether you need an early morning departure or a late-night return, we’re here to provide reliable service that fits your travel schedule."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Outstation Trip",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you need to make stops along the way, have specific locations to visit, or require special arrangements, we offer customizable itineraries to suit your preferences and make your outstation journey even more enjoyable."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Pune outstation cab with S9 Travels is simple and hassle-free. You can easily book your ride online through our website or mobile app, or contact our customer service team for personalized assistance. We strive to make your booking process quick, easy, and convenient."
  }
]
















    }


    const faqData = [
        [
          {
            question: 'How can I book an outstation cab from Pune with S9 Travels?',
            answer: 'Booking an outstation cab from Pune is simple! You can book your ride via our website, mobile app, or by contacting our customer service team for personalized assistance. We’ll ensure a comfortable and hassle-free journey to your destination.',
          },
          {
            question: 'What types of vehicles are available for outstation trips from Pune?',
            answer: 'We offer a range of vehicles for outstation trips from Pune, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the vehicle that best suits your group size and travel preferences.',
          },
          {
            question: 'Are the drivers experienced for outstation trips from Pune?',
            answer: 'Yes, our drivers are highly experienced in handling outstation trips from Pune. They are familiar with the best routes and ensure your safety and comfort during the journey.',
          },
          {
            question: 'Can I book a round-trip cab for outstation travel from Pune?',
            answer: 'Yes, you can book a round-trip cab for outstation travel from Pune. Simply provide us with your return details, and we will ensure a smooth and timely return journey.',
          },
          {
            question: 'How long in advance should I book an outstation cab from Pune?',
            answer: 'We recommend booking your outstation cab at least 1-2 days in advance to ensure vehicle availability and secure your preferred travel time. However, last-minute bookings can also be accommodated based on availability.',
          },
          {
            question: 'Is there a fixed fare for outstation cab services from Pune?',
            answer: 'The fare for outstation trips from Pune depends on the distance, type of vehicle, and specific requirements. Contact us for a customized quote, and we’ll provide you with transparent pricing based on your trip details.',
          },
          {
            question: 'Do you offer pick-up services from Pune airport or hotels for outstation trips?',
            answer: 'Yes, we provide convenient pick-up services from Pune airport or hotels for your outstation journey. Our drivers will ensure a smooth transfer to your destination.',
          },
          {
            question: 'Can I request additional stops on the way during an outstation trip from Pune?',
            answer: 'Yes, we can accommodate additional stops for meals, sightseeing, or other breaks during your outstation trip from Pune. Simply inform us during the booking process, and we’ll customize the itinerary to fit your preferences.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during outstation trips?',
            answer: 'Any extra charges for waiting time or detours will be communicated to you upfront during the booking process. We ensure full transparency in pricing, so there are no hidden costs.',
          },
          {
            question: 'Why should I choose S9 Travels for my outstation cab service from Pune?',
            answer: 'S9 Travels offers reliable, safe, and comfortable outstation cab services from Pune. With well-maintained vehicles, professional drivers, and excellent customer service, we ensure a smooth and enjoyable journey to your destination.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked an outstation cab from Pune to Lonavala with S9 Travels, and the experience was fantastic. The driver was courteous and professional, and the vehicle was clean and comfortable. The journey was smooth and enjoyable. Highly recommend their service for outstation trips!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our outstation trip from Pune to Mahabaleshwar with S9 Travels was wonderful. The vehicle was spacious, and the driver was experienced and friendly. The trip was comfortable, and the scenic route was beautiful. We will definitely use S9 Travels again for our future outstation trips.”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
     
 const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Pune Outstation Cab Service – S9 Travels",
    "image": "https://s9travels.com/images/keyword/pune-outstation-cab.jpg",
    "description":
      "Book reliable Pune Outstation Cabs with S9 Travels for family trips, business travel, or weekend getaways. Choose AC Hatchback, Sedan, SUV, or Innova Crysta for safe and comfortable rides to destinations like Mumbai, Shirdi, Mahabaleshwar, Lonavala, Goa, and Nashik with 24/7 service and professional chauffeurs.",
    "brand": { "@type": "Brand", "name": "S9 Travels" },
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.9",
      "ratingCount": "9583"
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "1499",
      "availability": "https://schema.org/InStock",
      "url": "https://s9travels.com/pune-outstation-cab"
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Which outstation cab routes are popular from Pune?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Top routes include Pune to Mumbai, Pune to Shirdi, Pune to Mahabaleshwar, Pune to Lonavala, Pune to Nashik, Pune to Goa, and Pune to Kolhapur. S9 Travels provides one-way, round-trip, and multi-day packages for all routes."
        }
      },
      {
        "@type": "Question",
        "name": "What are the Pune outstation cab charges?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Outstation cab fares from Pune start from ₹1499 for Hatchback and vary based on distance, duration, and vehicle type. All fares are transparent with no hidden costs."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide 24/7 outstation cab service from Pune?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Yes, S9 Travels offers 24x7 Pune outstation cab services. You can book day or night trips anytime with instant confirmation and professional chauffeurs."
        }
      },
      {
        "@type": "Question",
        "name": "Are round-trip and one-way bookings available?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Yes, S9 Travels offers flexible booking options for both one-way and round-trip journeys. Choose from Hatchback, Sedan, SUV, or Innova Crysta as per your travel requirement."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "S9 Travels",
    "image": "https://s9travels.com/images/logo.png",
    "url": "https://s9travels.com/",
    "telephone": "+91 7090759555",
    "priceRange": "₹₹",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Wakad Road, Pimpri-Chinchwad",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "postalCode": "411057",
      "addressCountry": "IN"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "ratingCount": "9583"
    },
    "openingHours": "Mo-Su 00:00-23:59",
    "areaServed":
      "Pune, Mumbai, Shirdi, Mahabaleshwar, Lonavala, Goa, Nashik, Kolhapur, Satara, Ahmednagar"
  };


    



    
     
    

    return (
        <div>
      <Helmet>
      {/* ✅ Title */}
      <title>
        Pune Outstation Cab from ₹1499 | One-Way & Round-Trip Taxi – S9 Travels
      </title>

      {/* ✅ Meta Description */}
      <meta
        name="description"
        content="Book Pune Outstation Cab Service from ₹1499 with S9 Travels. Enjoy AC cars with verified chauffeurs for trips to Mumbai, Shirdi, Mahabaleshwar, Lonavala, Goa & more. 24x7 service, on-time pickup & affordable fares."
      />

      {/* ✅ Meta Keywords */}
      <meta
        name="keywords"
        content="Pune Outstation Cab, Outstation Taxi Pune, Pune to Mumbai Cab, Pune to Shirdi Cab, Pune to Mahabaleshwar Cab, Pune to Lonavala Cab, Pune to Nashik Cab, Pune to Goa Taxi, Outstation Car Rental Pune, S9 Travels Outstation Cab Service"
      />

      {/* ✅ Canonical URL */}
      <link rel="canonical" href="https://s9travels.com/pune-outstation-cab" />

      {/* ✅ Structured Data */}
      <script type="application/ld+json">{JSON.stringify(productSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>

      {/* ✅ Open Graph Meta */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Pune Outstation Cab from ₹1499 | 24x7 One-Way & Round-Trip Taxi | S9 Travels"
      />
      <meta
        property="og:description"
        content="Hire outstation cabs from Pune starting ₹1499 with S9 Travels. AC Hatchback, Sedan, SUV & Innova Crysta with professional drivers for safe, comfortable journeys."
      />
      <meta
        property="og:image"
        content="https://s9travels.com/images/keyword/pune-outstation-cab.jpg"
      />
      <meta property="og:url" content="https://s9travels.com/pune-outstation-cab" />
      <meta property="og:site_name" content="S9 Travels" />

      {/* ✅ Twitter Card Meta */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Pune Outstation Cab from ₹1499 | One-Way & Round-Trip Taxi | S9 Travels"
      />
      <meta
        name="twitter:description"
        content="Book affordable Pune Outstation Cab from ₹1499. Safe, comfortable & 24x7 AC cab service with verified chauffeurs and instant booking confirmation."
      />
      <meta
        name="twitter:image"
        content="https://s9travels.com/images/keyword/pune-outstation-cab.jpg"
      />
    </Helmet>
 


      
      

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/62.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetooutstationcab;